var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex items-center" }, [
    _c("label", { staticClass: "inline-flex items-center cursor-pointer" }, [
      _c("input", {
        staticClass: "hidden",
        attrs: { type: "checkbox" },
        domProps: { checked: _vm.value },
        on: {
          change: function ($event) {
            return _vm.updateValue($event)
          },
        },
      }),
      _c("span", { staticClass: "checkbox-custom" }, [
        _vm.value
          ? _c(
              "svg",
              {
                staticClass: "w-3 h-3 text-white",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z",
                  },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _c("span", { staticClass: "ml-2 text-sm text-gray-700" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }